import { render } from "./UpgleList.vue?vue&type=template&id=aef396ca&scoped=true"
import script from "./UpgleList.vue?vue&type=script&lang=js"
export * from "./UpgleList.vue?vue&type=script&lang=js"

import "./UpgleList.vue?vue&type=style&index=0&id=aef396ca&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef396ca"]])

export default __exports__